import { Injectable } from "@angular/core";
import { AccountService } from "@app/main/modules/foundation/_services/account.service";
import { AccountFeatureService, IAccountFeatureDescription, IAccountFeatureDescriptionMap, ISpecialUserPermissionDescriptionMap } from "@app/services/accountFeature.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class UserEditorService {
    constructor(
        private readonly accountFeatureService: AccountFeatureService,
        private readonly accountService: AccountService) { }

    getFeatureDescriptions(accountId: number): Observable<IAccountFeatureDescription[]> {
        return this.accountService.getCustomerAccount(accountId).pipe(
            map(account => {
                return this.accountFeatureService.getFeatureDescriptionsForAccount(account);
            })
        )
    }
}


